import moment from 'moment';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import withCotizacion from '../../HOC/withCotizacion';

const ModalTransaccionesPendientes = ({
  setModalShow,
  show,
  cotizacion,
  ...props
}) => {
  const { transaccionesPendientesPTP } = cotizacion;
  const close = () => {
    setModalShow(false);
  };

  if (!!!transaccionesPendientesPTP) {
    return null;
  }

  return (
    <Modal
      show={show}
      onHide={close}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Transacciones Pendientes
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {transaccionesPendientesPTP.map((item, index) => (
          <React.Fragment key={index}>
            <hr />
            <p>
              <strong>Producto:</strong> {item.productoNombre}
            </p>
            <p>
              <strong>Valor:</strong>{' '}
              {Math.round(100 * item.valoresPagar.total) / 100}
            </p>
            <p>
              <strong>Fecha:</strong>
              {moment(item.fechaCreacion, 'yyyy/MM/DD HH:mm')
                .format('[ ]dddd DD [de] MMMM [de] yyyy [a las ]')
                .toUpperCase() +
                moment(item.fechaCreacion, 'yyyy/MM/DD HH:mm')
                  .format('HH:mm a')
                  .toUpperCase()}
            </p>
            <hr />
          </React.Fragment>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={close}>Cerrar</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default withCotizacion(ModalTransaccionesPendientes);
